import { Form, Row } from 'antd';
import { AButton } from '../Button';
import { LeftCircleOutlined, SaveOutlined } from '@ant-design/icons';

interface IOptionFooter {
  width?: string;
  onClickCancel?:
    | (React.MouseEventHandler<HTMLAnchorElement> &
        React.MouseEventHandler<HTMLButtonElement>)
    | undefined;
  cancelText?: string | null;
  okText?: string | null;
  onClickOk:
    | (React.MouseEventHandler<HTMLAnchorElement> &
        React.MouseEventHandler<HTMLButtonElement>)
    | undefined;
  disabled?: boolean;
  iconCancel?: React.ReactNode | null;
  iconOk?: React.ReactNode | null;
  showOk?: boolean;
}

export const OptionFooter: React.FC<IOptionFooter> = ({
  width,
  onClickOk,
  cancelText,
  okText,
  onClickCancel,
  disabled,
  iconCancel,
  iconOk,
  showOk = true,
}) => {
  return (
    <Form layout="vertical" style={{ width: width ?? '100%', marginTop: 20 }}>
      <Row justify="end">
        <AButton
          type="default"
          onClick={onClickCancel}
          icon={iconCancel ?? <LeftCircleOutlined />}
        >
          {cancelText ?? 'Voltar'}
        </AButton>
        {showOk && (
          <AButton
            type="primary"
            onClick={onClickOk}
            disabled={disabled}
            icon={iconOk ?? <SaveOutlined />}
          >
            {okText ?? 'Salvar'}
          </AButton>
        )}
      </Row>
    </Form>
  );
};
